import React from 'react'
import SVGInline from '@/v2/components/common/SVGInline'
import VisaIcon from '#/assets/images/v2/icons/visa.svg?raw'
import MasterIcon from '#/assets/images/v2/icons/master.svg?raw'
import AmexIcon from '#/assets/images/v2/icons/amex.svg?raw'
import DinersIcon from '#/assets/images/v2/icons/diners.svg?raw'
import JcbIcon from '#/assets/images/v2/icons/jcb.svg?raw'
import GenericIcon from '#/assets/images/v2/icons/generic.svg?raw'

export const getCreditCardIcon = brand => {
  switch (brand) {
    case 'mastercard':
      return <SVGInline svg={MasterIcon} width="70px" height="29px" />
    case 'visa':
      return <SVGInline svg={VisaIcon} width="70px" height="29px" />
    case 'amex' || 'american-express':
      return <SVGInline svg={AmexIcon} width="70px" height="29px" />
    case 'diners':
      return <SVGInline svg={DinersIcon} width="70px" height="29px" />
    case 'jcb':
      return <SVGInline svg={JcbIcon} width="70px" height="29px" />
    default:
      return <SVGInline svg={GenericIcon} width="70px" height="29px" />
  }
}
